export default "/_next/static/images/signin-3-563d68cb94931bdfdff0cef2050c8582.png";